export default __webpack_public_path__ + "static/17-fd685b0c8e31faabcb413cfe3b914314.jpg";